<template>
  <b-modal
      id="correction"
      size="xl"
      static
  >
    <b-input-group prepend="Correction" class="mb-3">
      <v-select
          ref="select"
          label="correction"
          :loading="loading"
          :clearable="false"
          :options="list"
          :reduce="val=>val.key"
          v-model="selectedKey"
          @input="deployCorrection">
        <template #search="{attributes, events}">
          <input
              ref="search"
              aria-label="search"
              class="vs__search"
              v-bind="attributes"
              v-on="events"
              v-model="search"
              @focusout="onLoseFocus"
              @focusin="onFocusIn"
          />
        </template>
        <template #option="{ correction, comment }">
          <em>{{ error }} -> </em><strong>{{ correction }}</strong><br>
          <em v-if="!!comment">{{ comment }}</em>
        </template>
      </v-select>
    </b-input-group>
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text">Commentaires</span>
      </div>
      <textarea
          class="form-control"
          v-model="comment"
          aria-label="Commentaires"
          rows="8"
      />
    </div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-1 variant="info">Texte original</b-button>
      </b-card-header>
      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
        <text-display :html="texte_original"></text-display>
      </b-collapse>
    </b-card>
    <template v-slot:modal-footer>
      <b-overlay spinner-variant="primary" :show="saveOverlay">
        <b-button variant="outline-primary" @click="saveCorrection">Sauver Correction</b-button>
      </b-overlay>
      <b-button variant="primary" @click="call">Corriger</b-button>
    </template>
  </b-modal>
</template>

<script>
import TextDisplay from "@/components/textDisplay";
import {Correction} from "../js/caller";

export default {
  name      : "correctionModal",
  components: {
    TextDisplay,
  },
  props     : ['error', 'texte_original', 'replace'],
  data      : () => {
    return {
      loading    : false,
      saveOverlay: false,

      list       : [],
      selectedKey: null,

      correction: "",
      comment   : "",

      prevVal: "",
      search : ""
    }
  },
  methods   : {
    deployCorrection(key) {
      const value     = this.list[key];
      this.correction = value.correction;
      this.comment    = value.comment;
      this.prevVal    = value.correction;
      this.search     = "";
    },
    saveCorrection() {
      this.saveOverlay                                      = true;
      const {error, correction, comment, list, selectedKey} = this
      const {id}                                            = list[selectedKey]
      Correction.Type.Save({id, error, correction, comment}).then(
          (res) => {
            this.$root.$emit("alert-success", "Correction sauvée");
            list[selectedKey].id = res.id
          },
          () => this.$root.$emit("alert-error", "La correction n'a pas été sauver")
      ).finally(() => {
        this.saveOverlay = false;
      });
      correction
    },
    getCorrections() {
      this.loading = true;
      Correction.Type
          .Get(this.error)
          .then(r => {
            this.list        = [
              {correction: this.error, comment: ""},
              ...r
            ].map((v, i) => {return {...v, key: i}});
            this.selectedKey = 0
            this.deployCorrection(this.selectedKey)
            this.loading = false;
          });
    },

    setup() {
      this.selectedKey = null;
      this.comment     = "";
      this.correction  = this.error;
    },
    call() {
      const {replace, error, correction, comment} = this;
      replace(error, correction, comment);
    },

    updateCorrection() {
      this.list[this.selectedKey].correction = this.search.trim() === "" ? this.prevVal : this.search;
    },
    onLoseFocus() {
      this.updateCorrection();
      this.deployCorrection(this.selectedKey)
    },
    onFocusIn() {
      this.search = this.prevVal;
    },
  },
  watch     : {
    "error"  : function() {
      this.setup();
      this.getCorrections();
    },
    "search" : function() {
      if (this.$refs.search === document.activeElement) this.updateCorrection();
    },
    "comment": function(comment) {
      if (this.selectedKey === null) return
      this.list[this.selectedKey].comment = comment;
    }
  },
}
</script>

<style>
.input-group > .v-select {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group > .v-select > .vs__dropdown-toggle {
  border: 0;
  height: 100%;
}

.input-group > .v-select > .vs__dropdown-menu {
  width: calc(100% + 2px);
  margin-left: -1px;
}

.input-group > .v-select > .vs__dropdown-menu > .vs__dropdown-option {
  width: 100%;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

.vs--single.vs--open .vs__selected {
  opacity: 0 !important;
}
</style>